
(function () {
    'use strict';

    angular.module('thankview.freeTrial')
        .controller('FreeTrialSetupController', ['$scope', 'ajax', function ($scope, ajax) {
            $scope.init = function () {
                $scope.industrySet = false;
                $scope.getIndustries();
            };

            $scope.getIndustries = () => {
                // 'Other' is allowed for business industry
                ajax.get('/api/industries').then(function (data) {
                    $scope.industries = data;
                });
            };
            $scope.init();
        }]);
}());
